import { types, actions } from './requests'
export const JOBLISTSTATE_TYPES = {
    ...types('JOBLISTSTATE'),
}
export const JOBLISTSTATE_ACTIONS = {
    ...actions('JOBLISTSTATE'),
}
